const FINISHED_UPLOADING = 'UPLOAD_FINISHED';
import { CLEAR_SELECTED_FILES } from '../addPhotos';

const initialState = {};

const currentlyUploading = (state = initialState, action) => {
  switch (action.type) {
    case FINISHED_UPLOADING:
      let uploadedId = {};
      if (action.success) {
        uploadedId[action.image.imageID.toLowerCase()] = true;
      }
      return { ...state, ...uploadedId };
    case CLEAR_SELECTED_FILES:
      return initialState;
    default:
      return state;
  }
};

export default currentlyUploading;
